import { render } from "./WagerDetailMobile.vue?vue&type=template&id=0f6fb8e4&scoped=true"
import script from "./WagerDetailMobile.vue?vue&type=script&lang=js"
export * from "./WagerDetailMobile.vue?vue&type=script&lang=js"

import "@/assets/scss/wager/wager-detail-mobile.scss?vue&type=style&index=0&id=0f6fb8e4&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6fb8e4"]])

export default __exports__